import "./DatiPersonaliRiconosciutoPage.css";
import { t } from "../../services/formatters";
import { Button } from "../../components/Button";
import { Breadcrumb } from "../../components/Breadcrumb";
import { Informative } from "../../components/Informative";
import { useDatiPersonaliRiconosciutoPage } from "./useDatiPersonaliRiconosciutoPage";
import { ErrorModal } from "../../components/ErrorModal";
import { FormDatiUtenteRiconosciuto } from "../../components/FormDatiUtenteRiconosciuto";
import { useEffect } from "react";
import {Riepilogo} from "../../components/Riepilogo";

export const DatiPersonaliRiconosciutoPage = () => {
  const { next, edit, read, isCreaAppuntamentoBusy, fetchErrorMessage, fetchError, setFetchError } = useDatiPersonaliRiconosciutoPage();

  useEffect(() => {
    window.dataLayer.push({
      event: "customPageview",
      virtualPageURL: "/fa3/fissa-appuntamento/dati-personali-riconosciuto",
      crmIdentification: "utente riconosciuto",
      funnelVersion: "nuovo",
      capFiliale: read("cap"),
      presa_info: read("solo_info"),
    });
  }, []);

  return (
    <div id="dati-personali-riconosciuto-page">
      <Breadcrumb />


      <div className={`section page-title-component center-on-tablet`}>
        <h1>
          <span>Ciao {read("nome")}!</span>
        </h1>
      </div>

      {read("id_filiale_direct") && (
        <Riepilogo />
      )}


      <FormDatiUtenteRiconosciuto onClick={edit} />

      <Informative />

      <div className="section text-center">
        <Button id="go-to-select-state-btn" onClick={next} classList="btn-responsive always-style" loading={isCreaAppuntamentoBusy()} text={t("fissa_appuntamento")} />
      </div>

      <ErrorModal
        open={fetchError}
        text={fetchErrorMessage}
        onCloseModal={() => {
          setFetchError(false);
        }}></ErrorModal>
    </div>
  );
};
